import { render, staticRenderFns } from "./Coffee.vue?vue&type=template&id=db200408&"
import script from "./Coffee.vue?vue&type=script&lang=ts&"
export * from "./Coffee.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports